import React from "react";
import { Code2, Handshake, Building2 } from "lucide-react";
import Reveal from "../common/Reveal";

const VALUES = [
  {
    icon: Code2,
    title: "Tech",
    desc: "다가오는 미래를 구현합니다.",
  },
  {
    icon: Handshake,
    title: "Service & Business",
    desc: "늘 어떤 형태로든 행동하고 실행합니다.",
  },
  {
    icon: Building2,
    title: "Corporate",
    desc: "더 나은 세상을 만들어갑니다.",
  },
];

const Values = () => {
  return (
    <section className="py-16">
      <div className="mx-auto max-w-7xl px-4 text-center sm:px-6 lg:px-8">
        <Reveal>
          <span className="text-sm font-semibold uppercase tracking-wide text-accent-600">
            Our Values
          </span>
          <h2 className="mt-3 break-keep text-3xl font-bold text-primary-900 sm:text-4xl">
            인재상
          </h2>
        </Reveal>

        <div className="mt-12 grid grid-cols-1 gap-6 sm:grid-cols-3">
          {VALUES.map(({ icon: Icon, title, desc }, index) => (
            <Reveal
              key={title}
              delay={index * 100}
              className="h-full rounded-xl border border-gray-100 p-8 transition-all duration-300 hover:-translate-y-1 hover:shadow-lg"
            >
              <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-primary-50">
                <Icon className="h-7 w-7 text-primary-700" strokeWidth={1.75} />
              </div>
              <h3 className="mt-5 text-xl font-bold text-primary-900">
                {title}
              </h3>
              <p className="mt-2 break-keep text-sm leading-relaxed text-gray-600">
                {desc}
              </p>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Values;
